/**
 * Q-panelens texter på svenska och engelska, efter enhetens språk (inte Q:s språkinställning, som gäller
 * talet). Resten av Qvenari är på svenska.
 */
const sv = {
  title: 'Q',
  close: 'Stäng',
  newChat: 'Ny chatt',
  settings: 'Inställningar',
  back: 'Tillbaka',
  mock: 'Låtsasläge',
  welcome: 'Hej! Vad kan jag hjälpa till med?',
  welcomeSub: 'Fråga om dina jaktmarker och jakter, eller be mig göra något. Tryck på mikrofonen för att prata.',
  noHome: 'Logga in för att prata med Q.',
  placeholder: 'Skriv till Q …',
  send: 'Skicka',
  attach: 'Bifoga bild',
  removeAttachment: 'Ta bort bilden',
  image: 'Bild',
  look: 'Titta',
  lookQuestion: 'Vad tittar jag på? Säg vad du ser och vad jag kan göra.',
  noCamera: 'Ingen kamera är på. Slå på kameran eller glasögonen i jakten först.',
  mic: 'Prata',
  micStop: 'Sluta lyssna',
  micInterrupt: 'Avbryt uppläsningen',
  listening: 'Lyssnar …',
  speaking: 'Läser upp …',
  thinking: 'Tänker …',
  noRecognition: 'Den här webbläsaren kan inte lyssna. Skriv i stället.',
  micDenied: 'Q får inte använda mikrofonen. Slå på det i inställningarna.',
  confirmTitle: 'Ska jag göra det här?',
  confirmTitleTap: 'Det här måste du godkänna',
  confirmHint: 'Svara ja eller nej, med rösten eller i textfältet.',
  tapHint: 'Tryck på Godkänn. Rösten räcker inte för det här.',
  tapSpoken: 'Tryck på Godkänn om du vill att jag gör det.',
  yes: 'Ja',
  no: 'Nej',
  approve: 'Godkänn',
  cancel: 'Avbryt',
  cancelled: 'Avböjt',
  approved: 'Godkänt',
  error: 'Något gick fel i Q.',
  network: 'Kunde inte nå Q. Kontrollera anslutningen.',
  // Inställningar
  language: 'Språk',
  langSv: 'Svenska',
  langEn: 'English',
  langAuto: 'Auto',
  langHint: 'Auto följer enhetens språk. Säg "speak English" eller "prata svenska" för att byta.',
  voice: 'Röst',
  voiceSv: 'Röst på svenska',
  voiceEn: 'Röst på engelska',
  voiceDefault: 'Standard',
  voiceTry: 'Prova',
  voiceNone: 'Uppläsning finns inte i den här webbläsaren.',
  engine: 'Röstalternativ',
  engineApple: 'Apple Lokal',
  engineEleven: 'Anthropic + ElevenLabs',
  engineOpenAI: 'ChatGPT',
  engineOpenAIHint: 'ChatGPT-rösten (OpenAI Realtime): ett riktigt samtal med låg fördröjning. Prata när du vill, avbryt genom att börja prata, och ställ följdfrågor. Tryck på mikrofonen igen för att lägga på.',
  rtAccount: 'Konto',
  rtAccountQvenari: 'Qvenaris konto',
  rtAccountOwn: 'Egen nyckel',
  rtBackground: 'Fortsätt med låst skärm',
  rtBackgroundHint: 'Samtalet fortsätter när skärmen låses eller du byter app. Stäng av för att använda webbvyns ljud som tidigare.',
  rtBilling: 'ChatGPT Plus eller Pro ingår inte: OpenAI fakturerar API-användning separat på platform.openai.com. Med egen nyckel betalar du själv där; med Qvenaris konto gäller en gräns per dag.',
  rtQvenariUsage: (used: number, limit: number | null) => (limit == null ? `I dag: ${used} samtal på Qvenaris konto.` : `I dag: ${used} av ${limit} samtal på Qvenaris konto.`),
  rtQvenariMissing: 'Qvenaris OpenAI-konto är inte kopplat än. Använd en egen nyckel.',
  rtKeyPlaceholder: 'sk-…',
  rtKeySave: 'Spara nyckel',
  rtKeyRemove: 'Ta bort nyckeln',
  rtKeySaved: (last4: string) => `Din nyckel slutar på …${last4}. Den sparas krypterad hos Qvenari och visas aldrig igen.`,
  rtKeyHint: 'Skapa nyckeln under API keys på platform.openai.com. Den sparas krypterad på Qvenaris server, aldrig i appen.',
  rtKeyChecking: 'Kontrollerar nyckeln hos OpenAI …',
  rtState: { idle: '', connecting: 'Ansluter till ChatGPT …', listening: 'Lyssnar – prata när du vill', thinking: 'Tänker …', speaking: 'Q pratar – börja prata för att avbryta', reconnecting: 'Förbindelsen bröts – ansluter igen …', error: 'Fel' } as Record<string, string>,
  rtHangUp: 'Lägg på',
  rtTimeout: 'Samtalet nådde längsta tiden och lades på.',
  rtNotAvailable: 'ChatGPT-rösten är inte tillgänglig. Lägg in en egen nyckel under inställningarna.',
  engineHint: 'ElevenLabs låter mer naturligt men kräver nät och kostar per tecken. Går det inte läses svaret upp med Apples röst.',
  engineUnavailable: 'ElevenLabs är inte kopplat på servern.',
  elevenLoading: 'Hämtar rösterna …',
  conversation: 'Samtalsläge',
  conversationHint: 'Q lyssnar igen efter varje svar, tills du säger "tack, det var allt".',
  readAloud: 'Läs upp svaren',
  readAloudHint: 'Svar på det du sagt läses alltid upp. Slå på för att också läsa upp svar på det du skrivit.',
  apps: 'Andra appar',
  appsHint: 'Ge Q tillgång till dina andra Q-appar. Q använder dem som du, utan ny inloggning.',
  appsChecking: 'Kollar dina appar …',
  appsNone: 'Du har inga andra Q-appar som går att koppla.',
  appsError: 'Kunde inte hämta dina appar.',
  appOnHint: (n: number) => `${n} verktyg`,
  appOffHint: 'Av. När du slår på kollar Q att du har ett konto.',
  appUnavailable: 'Svarar inte just nu.',
  appNoAccount: (name: string) => `Du har inget konto i ${name}.`,
  appStart: 'Från dina appar',
  clearHistory: 'Rensa historik',
  clearHistoryConfirm: 'Rensa alla samtal med Q på den här enheten?',
  historyCleared: 'Historiken är rensad.',
  usage: (used: number, limit: number | null) => (limit == null ? `${used} frågor i dag` : `${used} av ${limit} frågor i dag`),
  suggestions: ['Vilka marker har jag?', 'När är nästa jakt?', 'Hur ser avskjutningen ut?', 'Vad skrivs i jaktlagets chatt?'],
};

type Texts = typeof sv;

const en: Texts = {
  title: 'Q',
  close: 'Close',
  newChat: 'New chat',
  settings: 'Settings',
  back: 'Back',
  mock: 'Mock mode',
  welcome: 'Hi! How can I help?',
  welcomeSub: 'Ask about your hunting grounds and hunts, or tell me to do something. Tap the microphone to talk.',
  noHome: 'Sign in to talk to Q.',
  placeholder: 'Message Q …',
  send: 'Send',
  attach: 'Attach image',
  removeAttachment: 'Remove image',
  image: 'Image',
  look: 'Look',
  lookQuestion: 'What am I looking at? Tell me what you see and what I can do.',
  noCamera: 'No camera is on. Turn on the camera or the glasses in the hunt first.',
  mic: 'Talk',
  micStop: 'Stop listening',
  micInterrupt: 'Stop reading',
  listening: 'Listening …',
  speaking: 'Speaking …',
  thinking: 'Thinking …',
  noRecognition: 'This browser cannot listen. Type instead.',
  micDenied: 'Q is not allowed to use the microphone. Turn it on in Settings.',
  confirmTitle: 'Shall I do this?',
  confirmTitleTap: 'You need to approve this',
  confirmHint: 'Answer yes or no, by voice or in the text field.',
  tapHint: 'Tap Approve. Your voice is not enough for this one.',
  tapSpoken: 'Tap Approve if you want me to do it.',
  yes: 'Yes',
  no: 'No',
  approve: 'Approve',
  cancel: 'Cancel',
  cancelled: 'Declined',
  approved: 'Approved',
  error: 'Something went wrong in Q.',
  network: 'Could not reach Q. Check your connection.',
  language: 'Language',
  langSv: 'Svenska',
  langEn: 'English',
  langAuto: 'Auto',
  langHint: 'Auto follows the device language. Say "speak English" or "prata svenska" to switch.',
  voice: 'Voice',
  voiceSv: 'Swedish voice',
  voiceEn: 'English voice',
  voiceDefault: 'Default',
  voiceTry: 'Try',
  voiceNone: 'Speech is not available in this browser.',
  engine: 'Voice option',
  engineApple: 'Apple Local',
  engineEleven: 'Anthropic + ElevenLabs',
  engineOpenAI: 'ChatGPT',
  engineOpenAIHint: 'ChatGPT voice (OpenAI Realtime): a real conversation with low latency. Talk whenever you like, interrupt by speaking, and ask follow-ups. Tap the microphone again to hang up.',
  rtAccount: 'Account',
  rtAccountQvenari: 'Qvenari\'s account',
  rtAccountOwn: 'Own key',
  rtBackground: 'Keep going when locked',
  rtBackgroundHint: 'The call continues when the screen locks or you switch apps. Turn off to use the web view\'s audio as before.',
  rtBilling: 'ChatGPT Plus or Pro is not included: OpenAI bills API usage separately at platform.openai.com. With your own key you pay there; with Qvenari\'s account there is a daily limit.',
  rtQvenariUsage: (used: number, limit: number | null) => (limit == null ? `Today: ${used} calls on Qvenari's account.` : `Today: ${used} of ${limit} calls on Qvenari's account.`),
  rtQvenariMissing: 'Qvenari\'s OpenAI account is not connected yet. Use your own key.',
  rtKeyPlaceholder: 'sk-…',
  rtKeySave: 'Save key',
  rtKeyRemove: 'Remove key',
  rtKeySaved: (last4: string) => `Your key ends in …${last4}. It is stored encrypted at Qvenari and never shown again.`,
  rtKeyHint: 'Create the key under API keys at platform.openai.com. It is stored encrypted on Qvenari\'s server, never in the app.',
  rtKeyChecking: 'Checking the key with OpenAI …',
  rtState: { idle: '', connecting: 'Connecting to ChatGPT …', listening: 'Listening – talk whenever you like', thinking: 'Thinking …', speaking: 'Q is talking – start talking to interrupt', reconnecting: 'Connection lost – reconnecting …', error: 'Error' } as Record<string, string>,
  rtHangUp: 'Hang up',
  rtTimeout: 'The call reached its maximum length and was ended.',
  rtNotAvailable: 'ChatGPT voice is not available. Add your own key in the settings.',
  engineHint: 'ElevenLabs sounds more natural but needs a connection and costs per character. If it fails, the answer is read with Apple\'s voice.',
  engineUnavailable: 'ElevenLabs is not connected on the server.',
  elevenLoading: 'Loading voices …',
  conversation: 'Conversation mode',
  conversationHint: 'Q listens again after every answer, until you say "thanks, that\'s all".',
  readAloud: 'Read answers aloud',
  readAloudHint: 'Answers to what you say are always read aloud. Turn on to also read answers to what you type.',
  apps: 'Other apps',
  appsHint: 'Give Q access to your other Q apps. Q uses them as you, without signing in again.',
  appsChecking: 'Checking your apps …',
  appsNone: 'You have no other Q apps to connect.',
  appsError: 'Could not load your apps.',
  appOnHint: (n: number) => `${n} tools`,
  appOffHint: 'Off. When you turn it on, Q checks that you have an account.',
  appUnavailable: 'Not responding right now.',
  appNoAccount: (name: string) => `You have no account in ${name}.`,
  appStart: 'From your apps',
  clearHistory: 'Clear history',
  clearHistoryConfirm: 'Clear all conversations with Q on this device?',
  historyCleared: 'History cleared.',
  usage: (used: number, limit: number | null) => (limit == null ? `${used} questions today` : `${used} of ${limit} questions today`),
  suggestions: ['Which hunting grounds do I have?', 'When is the next hunt?', 'How is the cull plan going?', 'What is new in the team chat?'],
};

export type QTexts = Texts;

/** Svenska om enheten är på svenska, annars engelska. */
export function qTexts(languages: readonly string[] = typeof navigator !== 'undefined' ? navigator.languages ?? [navigator.language] : []): QTexts {
  return languages.find(Boolean)?.toLowerCase().startsWith('sv') ? sv : en;
}
